import React from "react";

const ButtonLink: React.FC<JSX.IntrinsicElements["button"]> = ({ className = "", ...props }) => (
  <button className={className + " link"} {...props} />
);

export default ButtonLink;
